module.exports = __webpack_public_path__ + "static/media/90.a7f7c4a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/90.png
// module id = 473
// module chunks = 0